import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GameTypeSettingMutationKeys } from '../../../keys'
import {
	UpdateGameTypeSettingRequest,
	UpdateGameTypeSettingResponse,
} from '../../../type'
import { updateGameTypeSetting } from '../../services'

interface UseMutationUpdateGameTypeSettingProps {
	id: string
	payload: UpdateGameTypeSettingRequest
}

export default function useMutationUpdateGameTypeSetting(
	props?: UseBaseMutationOptions<
		UpdateGameTypeSettingResponse,
		UseMutationUpdateGameTypeSettingProps
	>,
) {
	return useMutation({
		mutationKey: [GameTypeSettingMutationKeys.UpdateGameTypeSetting],
		mutationFn: (params) => updateGameTypeSetting(params.id, params.payload),
		...props,
	})
}
